import React from "react";
import PropTypes from "prop-types";
import { Box, Button, Typography, Modal, CircularProgress } from "@mui/material";
import { ReactComponent as FIVBLogo } from "assets/images/icons/fivb-logo-large.svg";
import "assets/styles.css";

export default function ExtractReportModal({
  open,
  onClose,
  onExtractPdf,
  onExtractXlsx,
  isLoading,
  errorMessage,
  title = "Extract Report",
  description = "Choose the format in which you'd like to extract your report",
  pdfLabel = "Extract PDF",
  xlsxLabel = "Extract XLSX",
  ariaLabel = "Extract Report",
}) {
  const handleClose = () => {
    if (!isLoading) {
      onClose();
    }
  };

  return (
    <Modal open={open} onClose={handleClose} aria-labelledby={ariaLabel}>
      <Box
        className="ExtractReportModal"
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: "40vw",
          boxShadow: 24,
          textAlign: "center",
        }}
      >
        {isLoading && (
          <CircularProgress
            size={18}
            sx={{ position: "absolute", top: "30px", right: "40px" }}
          />
        )}
        <FIVBLogo className="FIVBLogoExtractReport" aria-hidden="true" />

        <Box className="ExtractReportTitles">
          <div className="ExtractReportTitleTypo">{title}</div>
          <div className="ExtractReportBodyTypo">{description}</div>
        </Box>

        {errorMessage && (
          <Box className="ExtractReportError" role="alert">
            {errorMessage}
          </Box>
        )}

        <Box className="ExtractReportButtons">
          <Button
            className="ExtractReportButton"
            onClick={onExtractPdf}
            disabled={isLoading}
            sx={{
              background: isLoading
                ? "var(--custom-accent-6, #CED5DA)"
                : "var(--Custom-Primary-Blue, #2732D4)",
              "&:hover": {
                background: isLoading
                  ? "var(--custom-accent-6, #CED5DA)"
                  : "#1F28B6",
              },
            }}
          >
            <Typography
              className="ExtractReportButtonTypo"
              sx={{
                color: isLoading ? "rgba(28, 28, 28, 0.40)" : "#F6F6F6",
              }}
            >
              {pdfLabel}
            </Typography>
          </Button>

          <Button
            className="ExtractReportButton"
            onClick={onExtractXlsx}
            disabled={isLoading}
            sx={{
              background: isLoading
                ? "var(--custom-accent-6, #CED5DA)"
                : "var(--Custom-Primary-Blue, #2732D4)",
              "&:hover": {
                background: isLoading
                  ? "var(--custom-accent-6, #CED5DA)"
                  : "#1F28B6",
              },
            }}
          >
            <Typography
              className="ExtractReportButtonTypo"
              sx={{
                color: isLoading ? "rgba(28, 28, 28, 0.40)" : "#F6F6F6",
              }}
            >
              {xlsxLabel}
            </Typography>
          </Button>
        </Box>
      </Box>
    </Modal>
  );
}

ExtractReportModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onExtractPdf: PropTypes.func.isRequired,
  onExtractXlsx: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
  errorMessage: PropTypes.string,
  title: PropTypes.string,
  description: PropTypes.string,
  pdfLabel: PropTypes.string,
  xlsxLabel: PropTypes.string,
  ariaLabel: PropTypes.string,
};

ExtractReportModal.defaultProps = {
  isLoading: false,
  errorMessage: "",
  title: "Extract Report",
  description: "Choose the format in which you'd like to extract your report",
  pdfLabel: "Extract PDF",
  xlsxLabel: "Extract XLSX",
  ariaLabel: "Extract Report",
};
